/* eslint-disable max-len */
import { observer } from 'mobx-react';
import { useMemo, useState } from 'react';
import PurchaseMember from './PurchaseMember';
import '../style.scss';
import { useStore } from '../../../core/utils/hook';
import { ACCOUNT_STATUS, SYSTEM_PATH } from '../../../core/configs/constants';

const HolderAllow = observer((props) => {
    // store
    const { authStore: { accountInfo, accountList, switchFreeAccount } } = useStore();
    
    //state
    const [navigateToPaidMember, setNavigate] = useState(false);
    const [isShow, setShow] = useState(true);
    
    //function
    const onChangeNavigate = (value) => setNavigate(value);

    const freeAccountModalShow = useMemo(() => {
        let show = false;
        if (accountInfo) {
            show =  accountInfo?.status === ACCOUNT_STATUS.SUBSCRIPTION_SUSPENDED.key && accountInfo?.allowAssignFreeAccount && !accountInfo?.isFreeAccount
        }
        return show;
    }, [accountInfo?.id]);

    const freeAccountInfor = useMemo(() => {
        if (accountList && accountList?.length) {
            let findFreeAccount = accountList.find(acc => acc.account?.isFreeAccount == true)

            if (findFreeAccount) {
                return findFreeAccount.account;
            }
        }
        return {};
    }, [accountList]);

    const onSwitchToFreeAccount = () => {
        switchFreeAccount();
        window.location.href = SYSTEM_PATH.HOLDER;
    }

    return isShow ? 
        <>
            { !navigateToPaidMember ?
                freeAccountModalShow ? (
                    <div className='modal-default modal-paid-member pd-t-20 pd-lr-16 '>
                        <p className='fs-heading-normal text-center font-semi-bold'>無料アカウントは<span>{freeAccountInfor?.userName}</span>となります。本アカウントをご利用の場合有料プランにてお申込みください。</p>
                        <div className='d-flex justify-content-center holder-option-btn mg-t-30 mg-b-15'>
                            <button className='btn btn-cs-1 min-width-150 text-color-cs-1' onClick={() => setNavigate(!navigateToPaidMember)}>
                                <span className='font-bold text-color-cs-1'>有料会員はコチラから</span>
                            </button>
                            <button className='btn btn-bg-cs-1 min-width-150' onClick={() => onSwitchToFreeAccount()}>
                                <span className='font-bold'>無料プランに移行する</span>
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className='modal-default modal-paid-member pd-t-20 pd-lr-16 '>
                        <p className='fs-heading-normal text-center font-semi-bold'>有料会員でないため、この機能は使用できません。</p>
                        <div className='d-flex justify-content-center mg-t-30 mg-b-15'>
                            <button className='btn btn-bg-cs-1 min-width-150' onClick={() => setNavigate(!navigateToPaidMember)}><span className='font-bold'>有料会員はコチラから</span></button>
                        </div>
                    </div>
                ) : (
                    <PurchaseMember 
                        navigateToPaidMember={navigateToPaidMember} 
                        onChangeNavigate={onChangeNavigate} 
                        callbackSendMailMessage={() => {
                            setShow(isShow);
                            setNavigate(!navigateToPaidMember);
                        }}
                        callbackSubmit={() => {
                            setShow(!isShow);
                        }}
                    />
                )
            }
        </> : <></>
})

export default HolderAllow;